import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ChevronUp } from 'lucide-react';

const ButtonWrapper = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  bottom: 32px;
  left: 32px;
  z-index: 1000;
  opacity: ${props => props.$isVisible ? 1 : 0};
  transform: ${props => props.$isVisible ? 'translateY(0)' : 'translateY(10px)'};
  pointer-events: ${props => props.$isVisible ? 'auto' : 'none'};
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    bottom: 20px;
    left: 20px;
  }
`;

const Button = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: white;
  color: var(--secondary-color);
  border: 1px solid var(--secondary-color);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;

  &:hover {
    border-color: var(--text-tertiary);
    color: var(--text-primary);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
  }
`;

const Tooltip = styled.span`
  position: absolute;
  left: calc(100% + 10px);
  top: 50%;
  transform: translateY(-50%);
  background: var(--text-primary);
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
    border: 5px solid transparent;
    border-right-color: var(--text-primary);
  }

  ${ButtonWrapper}:hover & {
    opacity: 1;
    visibility: visible;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const BackToTopButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <ButtonWrapper $isVisible={isVisible}>
      <Tooltip>למעלה</Tooltip>
      <Button onClick={scrollToTop} aria-label="חזרה למעלה">
        <ChevronUp size={20} />
      </Button>
    </ButtonWrapper>
  );
};

export default BackToTopButton;
